import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

/** Wrapper de Formly: añade «¿Quisiste decir X?» bajo un campo de email. */
@Component({
  selector: 'formly-wrapper-email-suggestion',
  template: `
    <ng-container #fieldComponent></ng-container>
    <app-email-suggestion [control]="formControl"></app-email-suggestion>
  `,
})
export class EmailSuggestionWrapperComponent extends FieldWrapper {}
